export default "__VITE_ASSET__BP_NA9cS__"